// Fixed lookup values seeded directly in the CRM schema (contact_role)
export const CONTACT_ROLES = [
  { ContactRoleID: 1, RoleName: 'Owner' },
  { ContactRoleID: 2, RoleName: 'Green Buyer' },
  { ContactRoleID: 3, RoleName: 'Accounting' },
  { ContactRoleID: 4, RoleName: 'Shipping' },
  { ContactRoleID: 5, RoleName: 'General Contact' }
];
